<template>
    <div class="relative group">
        <a class="flex items-center p-2 bg-secondary-100 mb-2" :href="line.url">
            <div class="mr-4">
                <div class="block w-14 aspect-square lazyload" :data-bg="line.image"></div>
            </div>

            <div class="flex-1">
                <div>{{ line.description }}</div>
                <div v-if="line.sampleSize" class="text-sm">{{ line.sampleSize }}</div>
            </div>

            <div class="pr-2 text-sm font-bold group-hover:hidden" :class="{ hidden: loading }">
                {{ new Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD' }).format(line.total) }}
            </div>

            <button
                class="group-hover:block mr-4 w-6 h-8 font-light text-2xl leading-none"
                :class="{ loading, hidden: !loading }"
                @click.prevent="onDeleteLine(line)"
            >
                &times;
            </button>
        </a>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('cart');

export default {
    props: {
        line: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
        };
    },

    methods: {
        ...mapActions([
            'removeFromCart',
        ]),

        async onDeleteLine(line) {
            this.loading = true;

            await this.removeFromCart(line.variantId);

            this.loading = false;
        },
    },
};
</script>
